import { useState } from "react";
import { Form, Button, Card, Container, Badge } from "react-bootstrap";
import API from "../services/api";
import { useNavigate } from "react-router-dom";
import { ShieldCheck } from "react-bootstrap-icons";
import { Eye, EyeSlash } from "react-bootstrap-icons";

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

 const handleLogin = async () => {
  if (loading) return;
  
  setLoading(true);

  const fd = new FormData();
  fd.append("email", email);
  fd.append("password", password);

  const res = await API.post("/auth/login.php", fd);

  if (res.data.status === "success") {
    localStorage.setItem("session_id", res.data.session_id);
    navigate("/enter-code");
  } else {
    alert(res.data.msg);

    if (res.data.redirect === "signup") {
      navigate("/signup");
    }
  }
  setLoading(false);
};

  return (
    <Container 
      fluid 
      className="min-vh-100 d-flex align-items-center justify-content-center bg-light"
      style={{ background: "linear-gradient(135deg, #f5f7fa 0%, #e4e9fd 100%)" }}
    >
      <Card 
        className="shadow-lg border-0" 
        style={{ maxWidth: "420px", width: "100%", borderRadius: "1.25rem", overflow: "hidden" }}
      >
        <Card.Body className="p-5 text-center">
          
          <div className="mb-4">
            <ShieldCheck size={64} className="text-primary mb-3" />
            <h3 className="fw-bold mb-1">Exam Portal</h3>
            <p className="text-muted">Enter your credentials to begin</p>
          </div>


          <Form className="text-start">
            <Form.Group className="mb-3">
              <Form.Label className="fw-medium">Email</Form.Label>
              <Form.Control
                type="email"
                placeholder="john@example.com"
                value={email}
                onChange={e => setEmail(e.target.value)}
                className="rounded-pill px-4 py-2 border-secondary-subtle"
              />
            </Form.Group>

            <Form.Group className="mb-4">
              <Form.Label className="fw-medium">Password</Form.Label>
              <div className="position-relative">
  <Form.Control
    type={showPassword ? "text" : "password"}
    placeholder="Enter your password"
    value={password}
    onChange={e => setPassword(e.target.value)}
    className="rounded-pill px-4 py-2 border-secondary-subtle pe-5"
  />

  <span
  className="eye-icon"
    onClick={() => setShowPassword(!showPassword)}
    style={{
      position: "absolute",
      right: "15px",
      top: "50%",
      transform: "translateY(-50%)",
      cursor: "pointer",
      color: "#6c757d"
    }}
  >
    {showPassword ? <EyeSlash size={18} /> : <Eye size={18} />}
  </span>
  
</div>
<div className="text-end mb-3 mt-2">
  <span
    style={{ cursor: "pointer", color: "#0d6efd", fontSize: "14px" }}
    onClick={() => navigate("/forgot-password")}
  >
    Forgot Password?
  </span>
</div>
            </Form.Group>

            <Button 
              variant="primary" 
              size="lg" 
              className="w-100 rounded-pill fw-bold py-3"
              onClick={handleLogin}
              disabled={loading}
            >


              {loading ? (
    <>
      <span className="spinner-border spinner-border-sm me-2"></span>
      Processing...
    </>
  ) : (
    "login"
  )}
            </Button>
          </Form>



        </Card.Body>
      </Card>
    </Container>
  );
};

export default Login;